export default "__VITE_ASSET__BjmzoIWX__"